import { Lock, ShieldAlert } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";
import {
    employeeProfileDeniedMessage,
    listDeniedEmployeeProfileSections,
} from "../../utils/employeeProfileAccess";

export const EmployeeProfileAccessBanner = ({
    action = "view",
    sections,
    className,
    title = "Access restricted",
    message,
}) => {
    const denied = listDeniedEmployeeProfileSections(action, sections);
    const text = message || employeeProfileDeniedMessage(action, sections);
    if (!text && !denied.length) return null;

    return (
        <div
            role="alert"
            className={cn(
                "flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100",
                className
            )}
        >
            <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-300" />
            <div className="min-w-0">
                <p className="text-sm font-semibold">{title}</p>
                <p className="mt-1 text-xs leading-relaxed">{text}</p>
            </div>
        </div>
    );
};

export const EmployeeProfileViewOnlyBanner = ({ sectionLabel = "this section", className }) => (
    <EmployeeProfileAccessBanner
        title="View only"
        message={`You can view ${sectionLabel}, but you don't have permission to edit.`}
        className={className}
    />
);

export const EmployeeProfileSectionBlocked = ({
    title = "This section",
    action = "view",
    message,
    className,
}) => {
    const verb = action === "edit" ? "edit" : "view";
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center rounded-2xl border border-dashed border-amber-300 bg-amber-50/70 px-6 py-10 text-center dark:border-amber-800 dark:bg-amber-950/20",
                className
            )}
        >
            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-200">
                <Lock className="h-5 w-5" />
            </div>
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white">{title}</h4>
            <p className="mt-1 max-w-md text-xs text-gray-600 dark:text-gray-400">
                {message || `You don't have permission to ${verb} this section. Ask an administrator to grant Employee profile access.`}
            </p>
        </div>
    );
};
